<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="margin-bottom05" v-if="errorMessage" :mensagem="errorMessage" />

    <div v-if="!showOSSelect">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Nro OS</label>
                    <div class="field-label field-label-end">{{ osSelecionada.cdipos }}</div>
                </div>

                <div class="form-item form-item-data">
                    <label class="label-caption">Data</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(osSelecionada.dtipos) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Bairro</label>
                    <div class="field-label">{{ osSelecionada.nmbairro }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Logradouro</label>
                    <div class="field-label">{{ osSelecionada.nmlogradouro }}</div>
                </div>
            </div>
            

            <div v-if="!showEncerramento">
                <div class="row row-space">
                    <ProdutoSelect class="form-item" :ckIp="true" v-model:produtoSelecionado="produtoSelecionado" required />

                    <div class="form-item-char20">
                        <label class="label-caption">Quantidadee</label>
                        <input type="text" class="input-right" v-model="edQuantidade" v-decimal-mask maxlength="10" required/>
                    </div>
                </div>

                <div class="row-end margin-top10">
                    <button class="btn-confirm" @click="salvarItem">Salvar Ítem</button>
                    <button @click="showEncerramento=true">Encerrar OS</button>
                    <button @click="cancelForm">Sair</button>
                </div>
            </div>
        </div>


        <div v-if="showEncerramento" class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-data">
                    <label class="label-caption">Data Início</label>
                    <input type="date" v-model="edDtInicio" required />
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Hora</label>
                    <input type="text" class="input-center" v-time-mask v-model="edHrInicio" required />
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Data Fim</label>
                    <input type="date" v-model="edDtFim" required />
                </div>

                <div class="form-itemchar10">
                    <label class="label-caption">Hora</label>
                    <input type="text" class="input-center" v-time-mask v-model="edHrFim" required />
                </div>

                <div class="form-item">
                    <label class="label-caption">Observações</label>
                    <input type="text" v-model="edObsExecucao" v-uppercase required maxlength="100" />
                </div>
            </div>

            <div class="row-end">
                <button class="btn-confirm" @click="salvarEncerramento">Gravar Encerramento</button>
                <button @click="showEncerramento=false">Retornar</button>
            </div>
        </div>


        <div class="form-edit-page">
            <table>
                <thead>
                    <tr>
                        <th class="col-width-integer">Produto</th>
                        <th>Descrição</th>
                        <th class="col-width-number">Quantidade</th>
                        <th class="col-width-acoes-2">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(obj, index) in lsItens" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                        <td class="col-width-integer right">{{ obj.cdproduto }}</td>
                        <td>{{ obj.nmproduto }}</td>
                        <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.qtd) }}</td>
                        <td class="col-width-acoes-2"><div class="row-left">
                            <button v-if="!showEncerramento" class="btn-icon btn-icon--trash" @click="excluiItem(obj)"></button>
                        </div></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div v-if="showOSSelect">
        <IpOsPesquisaPage
            :idSituacao="5"
            :idSituacao2="7"
            @cancel="cancelForm"
            @select="selecionarOS" />
    </div>
</template>
  
<script setup>
import { ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericDelete, genericPost, genericPut } from '@/funcoes/api';
import { globalStore } from '@/globals';
import IpOsPesquisaPage from './IpOsPesquisaPage.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import ProdutoSelect from '@/selects/ProdutoSelect.vue';

const emit = defineEmits(['close', 'salvo']);

const edDtInicio = ref(null);
const edDtFim = ref(null);
const edHrInicio = ref(null);
const edHrFim = ref(null);
const edQuantidade = ref(null);
const edObsExecucao = ref(null);
const errorMessage = ref(null);
const isLoading = ref(false);
const lsItens = ref([]);
const osSelecionada = ref(null);
const produtoSelecionado = ref(null);
const showEncerramento = ref(false);
const showOSSelect = ref(true);

const cancelForm = () => {emit('close');};

const excluiItem = async(item) => {
    const confirmacao = window.confirm("Confirma exclusão do ítem?");
    if (confirmacao){
        try{
            isLoading.value=true;
            const r = await genericDelete('ipos_itens', item.id, globalStore.idusuario);
            if (r) {lerDados();}
        } catch(error){errorMessage.value=error;
        }finally{isLoading.value=false;}
    }
}

const lerDados = async() => {
    try{
        isLoading.value=true;
        const req = await genericPost('/ip/ipos/itens', {idos: osSelecionada.value.id});
        lsItens.value = req;
    }catch(error){errorMessage.value = error;
    }finally{isLoading.value=false;}
};

const selecionarOS = (os) => {
    showOSSelect.value      = false;
    osSelecionada.value     = os;
    lerDados();
};

const salvarItem = async () => {
    try {
        if (!produtoSelecionado.value) throw new Error('Informe o produto');
        if (!edQuantidade.value) throw new Error('Informe a quantidade');
        isLoading.value = true;
        errorMessage.value = null;
        const response  = await genericPut('/cad/ipos_item', {id: 0, idipos: osSelecionada.value.id, idproduto: produtoSelecionado.value,
            qtd: Funcoes.decimalFromString(edQuantidade.value), idusuario: globalStore.idusuario});
        if (response.bolok === 1){
            produtoSelecionado.value=null;
            edQuantidade.value = null;
            lerDados();
        }else{
            errorMessage.value=response.erro;
        }
    } catch (error) {errorMessage.value=`ATENÇÃO: ${error.message}`;
    } finally{isLoading.value=false;}
};

const salvarEncerramento = async() => {
    try{
        if (!edDtInicio.value) throw new Error('Informe data de início');
        if (!edDtFim.value) throw new Error('Informe data de encerramento');
        if (!edObsExecucao.value) throw new Error('Informe data de encerramento');
        isLoading.value=true;
        const r1 = await genericPut('/cad/ipos_evento', {
            id: 0,
            idipos: osSelecionada.value.id,
            idresponsavel: globalStore.idusuario,
            dtevento: edDtInicio.value,
            hrevento: edHrInicio.value,
            tpevento: 1,
            origem_sistema: 'WEB',
            idusuario: globalStore.idusuario});
        if (r1.bolok===1){
            const r2 = await genericPut('/cad/ipos_evento', {
                id: 0,
                idipos: osSelecionada.value.id,
                idresponsavel: globalStore.idusuario,
                dtevento: edDtFim.value,
                hrevento: edHrFim.value,
                tpevento: 3,
                detalhamento: edObsExecucao.value,
                origem_sistema: 'WEB',
                idusuario: globalStore.idusuario});
            if (r2.bolok===1){
                emit('salvo');
                emit('close');
            }else{errorMessage.value=`ATENÇÃO: ${r2.erro}`;}
        }else{errorMessage.value=`ATENÇÃO: ${r1.erro}`;}
    } catch (error) {errorMessage.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}
</script>